<!-- Modern Angular Material UI Component -->
<div *ngIf="usuario?.sucesso" class="modern-container">
  <app-mat-spinner-overlay [overlay]="true" *ngIf="loading > 0"></app-mat-spinner-overlay>

  <div class="form-section">
    <!-- Breadcrumb Navigation -->
    <div class="header-section">
      <nav aria-label="breadcrumb">
        <ul class="breadcrumb">
          <li><strong>Onde estou:</strong></li>
          <li class="active">
            <span>{{ tituloFuncionalidade }}</span>
          </li>
        </ul>
      </nav>
    </div>

    <div class="info-section" *ngIf="selectedFleet">
      <span class="info-item"><strong>Frota Selecionada:</strong> {{ selectedFleet.nomeReduzido }}</span>
      <span class="info-item"><strong>Código:</strong> {{ selectedFleet.codigo }}</span>
      <span class="info-item"><strong>Descrição:</strong> {{ selectedFleet.descricao }}</span>
    </div>

    <!-- Tab Group -->
    <mat-tab-group (selectedTabChange)="onTabChange($event)">
      <mat-tab label="Frota">
        <div class="tab-content">
          <div class="form-section">
            <!-- Info Card -->

            <!-- Formulário de horários e dias da semana -->
            <form [formGroup]="restrictionForm" (ngSubmit)="onAddRestriction()" *ngIf="selectedFleetId">
              <div class="form-row">
                <!-- Time Input Fields -->
                <mat-form-field appearance="outline">
                  <input matInput formControlName="horaInicio" placeholder="HH:MM" (input)="formatTime($event, 'horaInicio')">
                  <mat-icon matPrefix>schedule</mat-icon>
                  <mat-error *ngIf="restrictionForm.get('horaInicio')?.errors?.['required']">
                    Hora inicial é obrigatória
                  </mat-error>
                  <mat-error *ngIf="restrictionForm.get('horaInicio')?.errors?.['invalidTime']">
                    Formato inválido (use HH:MM)
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Hora Final</mat-label>
                  <input matInput formControlName="horaFim" placeholder="HH:MM" (input)="formatTime($event, 'horaFim')">
                  <mat-icon matPrefix>schedule</mat-icon>
                  <mat-error *ngIf="restrictionForm.get('horaFim')?.errors?.['required']">
                    Hora final é obrigatória
                  </mat-error>
                  <mat-error *ngIf="restrictionForm.get('horaFim')?.errors?.['invalidTime']">
                    Formato inválido (use HH:MM)
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Days Selection + Botão Incluir -->
              <div class="dias-e-incluir-row">
                <div class="dias-semana-toggle">
                  <mat-label>Selecione os dias da semana</mat-label>

                  <mat-slide-toggle color="secondary" class="toggle-all btn-secondary" (change)="onToggleTodosDias($event)">
                    Aplicar para todos os dias da semana
                  </mat-slide-toggle>

                  <mat-button-toggle-group formControlName="diasSelecionados" multiple class="toggle-group"
                    aria-label="Dias da semana">
                    <mat-button-toggle *ngFor="let dia of diasDaSemana" [value]="dia.control">
                      {{ dia.label }}
                    </mat-button-toggle>
                  </mat-button-toggle-group>

                  <!-- Error Message -->
                  <mat-error *ngIf="errorMessage" class="error-message">
                    <mat-icon>error_outline</mat-icon>
                    {{ errorMessage }}
                  </mat-error>
                </div>
                <div class="form-actions-inline">
                  <button type="button" (click)="onAddRestriction()" class="btn btn-secondary" [disabled]="restrictionForm.invalid">
                    Incluir
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Subfrota" [disabled]="!selectedFleetId">
        <div class="tab-content">
          <div class="form-section">
            <div class="section-title">
              <mat-icon>business</mat-icon>
              <span>Subfrota</span>
            </div>
            <div class="row">
              <div class="col-md-12 form-group mb-2">
                <div class="superComboDiv">
                  <app-filtro-subfrota [selectedSubFrota]="selectedSubFleet" (onSubfrotaSelected)="onSubfrotaSelected($event)"></app-filtro-subfrota>
                </div>
              </div>
            </div>

            <!-- Formulário de horários e dias da semana para Subfrota -->
            <form [formGroup]="restrictionForm" (ngSubmit)="onAddRestriction()" *ngIf="selectedSubFleetId">
              <div class="form-row">
                <!-- Time Input Fields -->
                <mat-form-field appearance="outline">
                  <input matInput formControlName="horaInicio" placeholder="HH:MM" (input)="formatTime($event, 'horaInicio')">
                  <mat-icon matPrefix>schedule</mat-icon>
                  <mat-error *ngIf="restrictionForm.get('horaInicio')?.errors?.['required']">
                    Hora inicial é obrigatória
                  </mat-error>
                  <mat-error *ngIf="restrictionForm.get('horaInicio')?.errors?.['invalidTime']">
                    Formato inválido (use HH:MM)
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Hora Final</mat-label>
                  <input matInput formControlName="horaFim" placeholder="HH:MM" (input)="formatTime($event, 'horaFim')">
                  <mat-icon matPrefix>schedule</mat-icon>
                  <mat-error *ngIf="restrictionForm.get('horaFim')?.errors?.['required']">
                    Hora final é obrigatória
                  </mat-error>
                  <mat-error *ngIf="restrictionForm.get('horaFim')?.errors?.['invalidTime']">
                    Formato inválido (use HH:MM)
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Days Selection + Botão Incluir -->
              <div class="dias-e-incluir-row">
                <div class="dias-semana-toggle">
                  <mat-label>Selecione os dias da semana</mat-label>

                  <mat-slide-toggle color="secondary" class="toggle-all btn-secondary" (change)="onToggleTodosDias($event)">
                    Aplicar para todos os dias da semana
                  </mat-slide-toggle>

                  <mat-button-toggle-group formControlName="diasSelecionados" multiple class="toggle-group"
                    aria-label="Dias da semana">
                    <mat-button-toggle *ngFor="let dia of diasDaSemana" [value]="dia.control">
                      {{ dia.label }}
                    </mat-button-toggle>
                  </mat-button-toggle-group>

                  <!-- Error Message -->
                  <mat-error *ngIf="errorMessage" class="error-message">
                    <mat-icon>error_outline</mat-icon>
                    {{ errorMessage }}
                  </mat-error>
                </div>
                <div class="form-actions-inline">
                  <button type="button" (click)="onAddRestriction()" class="btn btn-secondary" [disabled]="restrictionForm.invalid">
                    Incluir
                  </button>
                </div>
              </div>
            </form>

            <div class="info-message" *ngIf="!selectedSubFleet">
              Selecione uma subfrota para gerenciar as restrições de horário.
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Veiculos" [disabled]="!selectedFleetId">
        <div class="tab-content">
          <div class="form-section">
            <div class="section-title">
              <mat-icon>directions_car</mat-icon>
              <span>Veículo</span>
            </div>
            <div class="row">
              <div class="col-md-6 form-group mt-2">
                <div class="superComboDiv">
                  <app-filtro-subfrota [selectedSubFrota]="selectedSubFleet" (onSubfrotaSelected)="onSubfrotaSelected($event)"></app-filtro-subfrota>
                </div>
              </div>
              <div class="col-md-6 form-group mt-2">
                <div class="superComboDiv">
                  <app-filtro-veiculo [codigoSubFrota]="selectedSubFleetId" (onVeiculoSelected)="onVeiculoSelected($event)"></app-filtro-veiculo>
                </div>
              </div>
            </div>

            <!-- Formulário de horários e dias da semana para Veículo -->
            <form [formGroup]="restrictionForm" (ngSubmit)="onAddRestriction()" *ngIf="selectedVehicleId">
              <div class="form-row">
                <!-- Time Input Fields -->
                <mat-form-field appearance="outline">
                  <input matInput formControlName="horaInicio" placeholder="HH:MM" (input)="formatTime($event, 'horaInicio')">
                  <mat-icon matPrefix>schedule</mat-icon>
                  <mat-error *ngIf="restrictionForm.get('horaInicio')?.errors?.['required']">
                    Hora inicial é obrigatória
                  </mat-error>
                  <mat-error *ngIf="restrictionForm.get('horaInicio')?.errors?.['invalidTime']">
                    Formato inválido (use HH:MM)
                  </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label>Hora Final</mat-label>
                  <input matInput formControlName="horaFim" placeholder="HH:MM" (input)="formatTime($event, 'horaFim')">
                  <mat-icon matPrefix>schedule</mat-icon>
                  <mat-error *ngIf="restrictionForm.get('horaFim')?.errors?.['required']">
                    Hora final é obrigatória
                  </mat-error>
                  <mat-error *ngIf="restrictionForm.get('horaFim')?.errors?.['invalidTime']">
                    Formato inválido (use HH:MM)
                  </mat-error>
                </mat-form-field>
              </div>

              <!-- Days Selection + Botão Incluir -->
              <div class="dias-e-incluir-row">
                <div class="dias-semana-toggle">
                  <mat-label>Selecione os dias da semana</mat-label>

                  <mat-slide-toggle color="secondary" class="toggle-all btn-secondary" (change)="onToggleTodosDias($event)">
                    Aplicar para todos os dias da semana
                  </mat-slide-toggle>

                  <mat-button-toggle-group formControlName="diasSelecionados" multiple class="toggle-group"
                    aria-label="Dias da semana">
                    <mat-button-toggle *ngFor="let dia of diasDaSemana" [value]="dia.control">
                      {{ dia.label }}
                    </mat-button-toggle>
                  </mat-button-toggle-group>

                  <!-- Error Message -->
                  <mat-error *ngIf="errorMessage" class="error-message">
                    <mat-icon>error_outline</mat-icon>
                    {{ errorMessage }}
                  </mat-error>
                </div>
                <div class="form-actions-inline">
                  <button type="button" (click)="onAddRestriction()" class="btn btn-secondary" [disabled]="restrictionForm.invalid">
                    Incluir
                  </button>
                </div>
              </div>
            </form>

            <div class="info-message mt-3" *ngIf="!selectedVehicleId">
              Filtre um veículo para buscar os horários.
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- Tabela global, aparece em todas as abas -->
  <div class="table-section" *ngIf="selectedFleetId || selectedSubFleetId || selectedVehicleId">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z0 desktop-only">
      <!-- Hora Início Column -->
      <ng-container matColumnDef="horaInicio">
        <th mat-header-cell *matHeaderCellDef>Hora Início</th>
        <td mat-cell *matCellDef="let row" [attr.data-label]="'Hora Início'">
          {{row.horaInicio}}
        </td>
      </ng-container>

      <!-- Hora Fim Column -->
      <ng-container matColumnDef="horaFim">
        <th mat-header-cell *matHeaderCellDef>Hora Fim</th>
        <td mat-cell *matCellDef="let row" [attr.data-label]="'Hora Fim'">
          {{row.horaFim}}
        </td>
      </ng-container>

      <!-- Domingo Column -->
      <ng-container matColumnDef="domingo">
        <th mat-header-cell *matHeaderCellDef>Domingo</th>
        <td mat-cell *matCellDef="let row" [attr.data-label]="'Domingo'" [attr.data-type]="'boolean'"
          [attr.data-value]="row.domingo">
          {{row.domingo ? 'Sim' : 'Não'}}
        </td>
      </ng-container>

      <!-- Segunda Column -->
      <ng-container matColumnDef="segunda">
        <th mat-header-cell *matHeaderCellDef>Segunda</th>
        <td mat-cell *matCellDef="let row" [attr.data-label]="'Segunda'" [attr.data-type]="'boolean'"
          [attr.data-value]="row.segunda">
          {{row.segunda ? 'Sim' : 'Não'}}
        </td>
      </ng-container>

      <!-- Terça Column -->
      <ng-container matColumnDef="terca">
        <th mat-header-cell *matHeaderCellDef>Terça</th>
        <td mat-cell *matCellDef="let row" [attr.data-label]="'Terça'" [attr.data-type]="'boolean'"
          [attr.data-value]="row.terca">
          {{row.terca ? 'Sim' : 'Não'}}
        </td>
      </ng-container>

      <!-- Quarta Column -->
      <ng-container matColumnDef="quarta">
        <th mat-header-cell *matHeaderCellDef>Quarta</th>
        <td mat-cell *matCellDef="let row" [attr.data-label]="'Quarta'" [attr.data-type]="'boolean'"
          [attr.data-value]="row.quarta">
          {{row.quarta ? 'Sim' : 'Não'}}
        </td>
      </ng-container>

      <!-- Quinta Column -->
      <ng-container matColumnDef="quinta">
        <th mat-header-cell *matHeaderCellDef>Quinta</th>
        <td mat-cell *matCellDef="let row" [attr.data-label]="'Quinta'" [attr.data-type]="'boolean'"
          [attr.data-value]="row.quinta">
          {{row.quinta ? 'Sim' : 'Não'}}
        </td>
      </ng-container>

      <!-- Sexta Column -->
      <ng-container matColumnDef="sexta">
        <th mat-header-cell *matHeaderCellDef>Sexta</th>
        <td mat-cell *matCellDef="let row" [attr.data-label]="'Sexta'" [attr.data-type]="'boolean'"
          [attr.data-value]="row.sexta">
          {{row.sexta ? 'Sim' : 'Não'}}
        </td>
      </ng-container>

      <!-- Sábado Column -->
      <ng-container matColumnDef="sabado">
        <th mat-header-cell *matHeaderCellDef>Sábado</th>
        <td mat-cell *matCellDef="let row" [attr.data-label]="'Sábado'" [attr.data-type]="'boolean'"
          [attr.data-value]="row.sabado">
          {{row.sabado ? 'Sim' : 'Não'}}
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="ACAO_APAGAR">
        <th mat-header-cell *matHeaderCellDef>Ações</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="warn" (click)="handleAction({link: 'deleteRestriction'}, row)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns;"></tr>
    </table>
  </div>
</div>